import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type DeleteArtistParams = {
  /** the artistProfileId you want to delete */
  profileId: string;
} & RequestConfig;

export const deleteArtistProfile = async ({
  profileId,
  config
}: DeleteArtistParams) =>
  api.delete<void>(`/api/artistprofile/${profileId}`, config);
